import clsx from 'clsx';

import PropTypes from 'prop-types';

import { DEFAULT_POST_CONFIG } from '@/lib/posts/defaultPostConfig';
import { YT_POST_ICONS } from '@/lib/posts/postIcon';
import { getPostType, POST } from '@/lib/posts/postTypes';
//lib
import { YOUTUBE } from '@/lib/socialProfile';

//components
import Post from '@/components/base/Post';
import HoverLabelAndAlbums from '@/components/base/Post/HoverLabelAndAlbums';

const YoutubePost = ({
    data,
    isLoading,
    config = undefined,
    openViewer = undefined,
    isExport = false,
    handleLabelsEvent = undefined,
    handleAlbumsEvent = undefined,
    postConfig = { hasHover: true, hasFooter: true, showLabels: true, showAlbums: true },
    showHeader = true,
    ...restProps
}) => {
    const type = getPostType({ network: YOUTUBE, type: data?.type });
    const mergedPostConfig = { ...DEFAULT_POST_CONFIG, ...postConfig };

    if (isLoading) {
        return <Post.Placeholder postType={POST} isExport={isExport} />;
    }

    return (
        <div className="w-full">
            {showHeader && <Post.Header data={data} isExport={isExport} />}
            <Post
                data={data}
                config={config}
                isLoading={isLoading}
                className={clsx('w-full bg-white', {
                    'p-0.5': !mergedPostConfig?.hasFooter,
                    'px-2 pt-2': mergedPostConfig?.hasFooter,
                    'dark:bg-icoDarkMode-anthracite': !isExport
                })}
                isExport={isExport}
                {...restProps}>
                {({ referenceElement }) => (
                    <>
                        <Post.Content className="w-full">
                            {mergedPostConfig?.hasHover ? (
                                <HoverLabelAndAlbums
                                    openViewer={openViewer}
                                    referenceElement={referenceElement}
                                    handleLabelsEvent={handleLabelsEvent}
                                    handleAlbumsEvent={handleAlbumsEvent}
                                    showLabels={mergedPostConfig?.showLabels}
                                    showAlbums={mergedPostConfig?.showAlbums}
                                    socialProfile={data?.social_profile}
                                />
                            ) : null}
                            {type ? (
                                <Post.PostTypeIcon type={YT_POST_ICONS[type]} isExport={isExport} />
                            ) : null}
                            <div className="square">
                                <Post.Image />
                            </div>
                        </Post.Content>
                        {mergedPostConfig?.hasFooter ? <Post.Footer type={type} /> : null}
                    </>
                )}
            </Post>
        </div>
    );
};

YoutubePost.propTypes = {
    data: PropTypes.object,
    isLoading: PropTypes.bool,
    config: PropTypes.object,
    openViewer: PropTypes.func,
    addLabel: PropTypes.func,
    addAlbum: PropTypes.func
};

export default YoutubePost;
